var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLightning(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 16,
    viewBox: "0 0 10 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.66808e-05 7.74569C1.66808e-05 8.57891 0.606298 8.57375 1.80381 8.97429L3.92673 9.69262C3.8022 10.2291 1.41931 14.4784 1.41931 14.9636C1.41931 15.5767 2.11322 16.0084 2.75652 15.3561L9.07167 9.01596C9.5781 8.50764 9.93508 8.3491 9.93508 7.7457C9.93508 7.308 9.47817 7.15581 9.19617 7.06278L6.00837 5.98872C6.06898 5.72756 6.49222 4.96994 6.63916 4.67493L7.93228 2.079C8.0755 1.79153 8.51577 1.03434 8.51577 0.717719C8.51577 0.104668 7.82186 -0.327023 7.17857 0.325232C7.00187 0.504388 6.85974 0.646674 6.68252 0.824572L0.863409 6.6654C0.644982 6.88464 1.66808e-05 7.40254 1.66808e-05 7.74569Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightning);
export default __webpack_public_path__ + "static/media/lightning.1947348daff1fc1cd69190782246124a.svg";
export { ForwardRef as ReactComponent };